<script lang="ts">
	import {
		ActionsContainer,
		AdvancedCardV2,
		IconButton,
		LabelListV2,
		Tooltip,
		Toggle,
	} from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { save_actions } from '../WebHooksHelpers/get_actions';
	import { get_local_ip, get_mode } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getExtSensorsStatus, hasExternalSensors } from 'src/helpers/ext_sensor_helpers';
	import { refactorString } from '../WebHooksHelpers/web_hooks_action_title_helper';

	let className = 'mb-s';
	export { className as class };
	export let setting, action, device;

	let title = refactorString(action, device);

	const dispatch = createEventDispatcher();
	let enabled = setting?.enabled;
	let waitForResponse = false;
	const type = enabled ? 'default' : 'info';
	const disabled = setting.urls.length < 1;
	let labelList = [{ value: setting?.urls?.length, icon: 'fas fa-brackets', type: type }];
	const toggleAction = async () => {
		waitForResponse = true;
		setting.waitForResponse = true;
		let _setting = Object.assign({}, { ...setting });
		enabled = !enabled;
		_setting.enabled = enabled;
		const res = await save_actions(
			device,
			_setting.enabled,
			action,
			_setting.urls,
			{},
			_setting.index,
			get_local_ip(device.id),
		);
		onSettingsResponse(res, device);
		waitForResponse = false;
	};
	const tooltipText: (disabled: boolean) => string = (disabled) => {
		return disabled ? $format('disabled_action_toggler') : '';
	};
</script>

<AdvancedCardV2 class={className} {title} hideSlotTitle={false} leftSlotBackground>
	<Tooltip placement="right" title={tooltipText(disabled)} slot="left">
		<Toggle
			aria-label={$format('toggle_action', {
				default: 'Toggle action',
			})}
			size="m"
			checked={enabled}
			disabled={disabled || waitForResponse}
			on:click={toggleAction}
			id="toggle-r3d1qh5"
		/>
	</Tooltip>

	<LabelListV2
		size="m"
		labelList={labelList.map((i) => ({
			...i,
			type: enabled ? null : 'disabled',
		}))}
		slot="main"
		a11yProps={{ isInteractive: false }}
	/>

	<ActionsContainer orientation="horizontal" type="simple" slot="right">
		<IconButton
			aria-label={$format('button_edit_action', {
				default: 'Button edit action',
			})}
			icon="fas fa-pen"
			slot="first"
			variant="primary"
			on:click={() => dispatch('edit', { setting, action })}
		/>
	</ActionsContainer>
</AdvancedCardV2>
